import React from 'react';

import { DiscoveryPluginsPanel } from '@/sections/customerManagement/components/masterDashboard/DiscoveryPluginsPanel';
import { HumanIntelligenceCredentialsPanel } from '@/sections/customerManagement/components/masterDashboard/HumanIntelligenceCredentialsPanel';
import { InfrastructureCredentialsPanel } from '@/sections/customerManagement/components/masterDashboard/InfrastructureCredentialsPanel';

export const MasterDashboard: React.FC = () => {
  return (
    <div className="flex h-full flex-col gap-4">
      <p className="text-chariot-text-secondary text-sm">
        Platform-wide configuration and data source management
      </p>
      <div className="h-full overflow-y-auto pb-6">
        <div className="flex flex-col gap-8">
          <DiscoveryPluginsPanel />
          <HumanIntelligenceCredentialsPanel />
          <InfrastructureCredentialsPanel />
        </div>
      </div>
    </div>
  );
};
